import { render, staticRenderFns } from "./CreateWeetSettingStep.vue?vue&type=template&id=28de89c8&scoped=true"
import script from "./CreateWeetSettingStep.vue?vue&type=script&lang=ts"
export * from "./CreateWeetSettingStep.vue?vue&type=script&lang=ts"
import style0 from "./CreateWeetSettingStep.vue?vue&type=style&index=0&id=28de89c8&prod&lang=scss"
import style1 from "./CreateWeetSettingStep.vue?vue&type=style&index=1&id=28de89c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de89c8",
  null
  
)

export default component.exports